import { Component, inject, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Cls_MobiDynamicTableDialog } from "../models";

@Component({
  selector: "mobi-office-lib-dynamic-table-dialog",
  templateUrl: "./dynamic-table-dialog.component.html",
  styleUrls: ["./dynamic-table-dialog.component.scss"],
  standalone: false,
})
export class DynamicTableDialogComponent {
  private dialogRef = inject(MatDialogRef<DynamicTableDialogComponent>);
  private data: Cls_MobiDynamicTableDialog = inject(MAT_DIALOG_DATA);

  constructor() {
    this.responseMessageList = this.data.responseMessage;
    if (this.data?.headerColumns?.length) this.headerColumns = this.data.headerColumns;
    if (this.data?.rowKeys?.length) this.rowKeys = this.data.rowKeys;
    if (this.data?.dialogHeading) this.dialogHeading = this.data.dialogHeading;
  }

  dialogHeading: string = "Request Info";
  responseMessageList: any[] = [];
  headerColumns: string[] = ["#", "Remark"];
  rowKeys: string[] = ["Code", "Remarks"];
}
